<template>
  <div class="school_design_detail">
      <!-- 详情标题 -->
      <div class="design_detail_title">{{ international_master_detail.name }}</div>
      <!-- 详情观看数 -->
      <div class="design_detail_use">
          <span><i class="iconfont">&#xe616;</i>{{ international_master_detail.popularity }}</span>
          <span><i class="iconfont">&#xe614;</i>{{ international_master_detail.collection_count }}</span>
          <span><i class="my_icon user"></i>{{ international_master_detail.apply_count }}</span>
      </div>
      <!-- 视频播放器 -->
      <div class="design_detail_video">
          <div class="video_player">
              <div id="player-con"></div>
          </div>
          <div class="video_catalog">
              <div class="catalog_title">
                  <div>{{ international_master_detail.name }}</div>
                  <div class="love" >
                      <i class="my_icon love" 
                      v-if="!international_master_detail.isCollection"
                      @click="collectionCourse"
                      ></i>
                      <i class="my_icon active_love" v-else @click="collectionCourse"></i>
                  </div>
              </div>
              <ul class="catalog_content">
                  <!-- <li class="catalog_content_item" v-for="(item,index) in video_list" :key="index" @click="playVideo(index)">
                      <div class="catalog_content_icon"><i class="my_icon active_play"></i></div>
                      <div class="catalog_content_name" >{{ item.videoName }}</div>
                  </li> -->
                  <li class="catalog_content_item" @click="playVideo">
                      <div class="catalog_content_icon"><i class="my_icon active_play"></i></div>
                      <div class="catalog_content_name" >{{ international_master_detail.videoName }}</div>
                  </li>
                  
              </ul>
              <!-- 免费报名 -->
              <div class="free_btn">
                  <el-button @click="schoolApply" v-if="!international_master_detail.isApply">立即报名</el-button>
                  <el-button class="applyed" v-if="international_master_detail.isApply" disabled>您已报名</el-button>
              </div>
          </div>
      </div>
      <div class="course_about_wrapper">
        <!-- 课程概述/评论 -->
        <div class="course_about_left">
            <div class="course_about">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="课程概述" name="first">
                        <!-- 课程概述 -->
                        <div class="course_overview ck-text" v-html="international_master_detail.synopsis"></div>
                    </el-tab-pane>
                    <el-tab-pane :label="'评论('+layerpageinfo.total+')'" name="second">
                        <!-- 评论 -->
                        <div class="course_comment">
                            <div class="unlogin_comment" v-if="!this.$store.state.info">
                                <!-- 未登录状态下 -->
                                <div class="unlogin_comment_btn">
                                    <el-button @click="login">登录</el-button>后发表评论
                                </div>
                            </div>
                            <div class="login_comment" v-else>
                                <!-- 登录状态下 -->
                                <el-input maxlength="200"
                                show-word-limit 
                                type="textarea" 
                                placeholder="说点什么..." 
                                v-model="comment"></el-input>
                            </div>
                            
                            <div class="send_btn">
                                <el-button v-if="this.comment" class="activeSend" @click="sendComment">评论</el-button>
                                <el-button @click="sendComment" v-else disabled>评论</el-button>
                            </div>
                            <ul class="comment_list" v-if="comment_list.length">
                                <li class="comment_item" v-for="(item,index) in comment_list" :key="index">
                                    <div class="comment_item_avatar">
                                        <img v-lazy="item.from_user_headPath">
                                    </div>
                                    <div class="comment_item_content">
                                        <div class="content_username">{{ item.from_user_name }}</div>
                                        <div class="content_wrapper">{{ item.content }}</div>
                                        <div class="content_date">{{ item.create_date }}</div>
                                    </div>
                                </li>
                            </ul>
                            <div v-else class="noComment">
                                暂时还没有评论哦！    
                            </div>    
                            <!-- 分页 -->
                            <div class="page_box">
                                <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
                            </div>
                        </div>
                    </el-tab-pane>   
                </el-tabs>
            </div>
        </div>
        <div class="course_about_right">
            <!-- 主讲人 -->
            <div class="keynote_speaker">
                <!-- 标题 -->
                <div class="item_title">主讲人</div>
                <!-- 内容 -->
                <div class="keynote_speaker_content">
                    <div class="keynote_speaker_img">
                        <img v-lazy="international_master_detail.speaker_headPath" alt="">
                    </div>
                    <div class="keynote_speaker_name">{{ international_master_detail.speaker }}</div>
                    <div class="keynote_speaker_introduce" >
                        {{ international_master_detail.speaker_synopsis || '暂无' }}
                    </div>
                </div>
            </div>
            <!-- 相关推荐 -->
            <div class="related_recommendation">
                <div class="item_title">相关推荐</div>
                <ul>
                    <li class="related_recommendation_content" v-for="item in recommend_list" :key="item.id">
                        <router-link target="_blank" :to="`/school_design_detail?id=${item.id}`"> 
                            <div class="recommendation_content_left">
                                <img v-lazy="item.coverPath" alt="">
                            </div>
                            <div class="recommendation_content_right">
                                <div class="recommendation_name">
                                    {{ item.name }}
                                </div>
                                <div class="looked">
                                    {{ item.popularity }} 人看过
                                </div>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import myPage from "@/components/myPage/myPage";
export default {
    components: {
        myPage
    },
    data(){
        return{
            activeName:'first',
            isLogin:false,
            comment:'',
            layerpageinfo: {
                pageSize: 10,
                pageNo: 0,
                total: 0
            },
            international_master_detail:{},    //详情
            comment_list:[],                   //评论列表
            recommend_list:[],                 //相关推荐列表 
            video_list:[],                     //视频列表
            video_link:'',                     //视频链接
            loading_love:true
        }
    },
    created(){
        // 获取详情
        this.getFrontColleges()        
        // 相关推荐
        this.schoolRecommend()
    },
    computed:{
        // 个人信息
        info(){
            return this.$store.state.info
        },
        // 登录弹框
        loginVisible() {
            return this.$store.state.isLoginDialog;
        }
    },
    methods:{
        // 获取详情
        getFrontColleges(){
            this.api.getFrontColleges({
                id:this.$route.query.id
            })
            .then(res => {
                if(res.error.err_code !== 0) return;
                let list = res.obj.list[0] || {};
                this.international_master_detail = list;
                // 视频
                // this.videoFile()
                // 评论列表
                this.getFrontEvaluates()
                // 阿里云播放器
                this.video()
            })
        },
        // 视频
        videoFile(){
            // let list = this.international_master_detail
            // // 素材链接
            // let videoPath = Object.keys(list.videoPath).length > 0 ? list.videoPath.split("|") : [];
            // // 素材名称
            // let videoName = Object.keys(list.videoName).length > 0 ? list.videoName.split("|") : [];
            // for(let i = 0;i<videoPath.length;i++){
            //     let obj = {
            //         videoPath:videoPath[i],
            //         videoName:videoName[i]
            //     }
            //     // 参考素材数组
            //     this.video_list.push(obj)
            // }
            // this.video_list = [
            //     {
            //       videoPath:'http://qq.8mins-show.com/f238b0adc0324bc1ad419da961800047/dbe9b182b56e49b78b0203219c5a2251-e11971f11319aa1638a794c276239ec5-od-S00000001-200000.mp4',
            //       videoName:'视频哈哈哈哈2222.mp4'
            //     },
            //     {
            //       videoPath:'http://qq.8mins-show.com/66c704d9cad74eaf81675ea14035aaae/3a23aeb892e941ac8b90a58cb676681a-6ee61a76017de4d0e889de531d28547e-od-S00000001-200000.mp4',
            //       videoName:'视频哈哈哈哈1111222.mp4'
            //     }
                
            // ]
            // console.log(this.video_list)
            // this.video_link = this.video_list[0].videoPath
            // 阿里云播放器
            // this.video()
        },
        // 阿里云播放器
        video(){
            this.player = new Aliplayer({
                "id": "player-con",
                "source": this.international_master_detail.videoPath,
                // "vid": this.roadShowparam.aliyun_videoId,
                // 'playauth': this.roadShowparam.aliyun_palyAuth,
                "width": "100%",
                "height": "495px",
                "autoplay": true,
                "isLive": false,
                "rePlay": false,
                "playsinline": true,
                "preload": true,
                "controlBarVisibility": "hover",
                "useH5Prism": true,
                "definition": 'FD,SD,HD,OD',
                "defaultDefinition": 'SD',
                }, (player) => {
                  this.player.play();
                }
            );
        },
        playVideo(){
            
        },
        // 播放视频
        // playVideo(index){
        //     this.video_link = this.video_list[index].videoPath
        //     // this.video_link = ''
        //     console.log(this.video_link)
        //     this.video()
        // },
        // 登录
        login(){
            this.$store.dispatch("setIsLoginDialog", true);
        },
        // 发送评论
        sendComment(){
            if(!this.comment.trim()){
                this.$message.info('发送消息不能为空！')
                return;
            }
            this.createFrontEvaluate()
            
        },
        // 创建评论
        createFrontEvaluate(){
            let obj = {
               grade:'ScoreGradeOneStar',
               from_user:this.$store.state.info.id,
               code:this.international_master_detail.code,
               content:this.comment
            }
            this.api.createFrontEvaluate(obj)
            .then(res => {
                console.log(res)
                if(res.error.err_code !== 0) return;
                this.$message.success('发送评论成功！')
                this.comment = ''
                this.video_list = []
                this.getFrontEvaluates()
            })
            
        },
        
        // 评论列表
        getFrontEvaluates(){
            let obj = {
                code:this.international_master_detail.code,
                ...this.layerpageinfo
            }
            this.api.getFrontEvaluates(obj)
            .then(res => {
                if(res.error.err_code !== 0) return;
                let list = res.obj.list;
                this.comment_list = list.length ? list : [];
                this.layerpageinfo.total = res.obj.totalSize;
            })
        },
        // 报名
        schoolApply(){
            if(!this.$store.state.info){
                this.$store.dispatch("setIsLoginDialog", true);
                return;
            }
            let obj = {
                code:this.international_master_detail.code,
                user_id:this.$store.state.info.id,
                type:'EntityTypeCollege'
            }
            this.api.schoolApply(obj)
            .then(res => {
                if(res.error.err_code !== 0) return;
                this.$message.success('报名成功');
                this.international_master_detail.isApply = true;
            })
        },
        // 页数切换
        changePage(pageNo) {
            this.layerpageinfo.pageNo = pageNo;
            this.getFrontEvaluates()
        },
        // 相关推荐
        schoolRecommend(){
            this.api.schoolRecommend({})
            .then(res =>{
                if(res.error.err_code !==0) return;
                let list = res.obj.list;
                this.recommend_list = list.length ? list : [];
            })
        },
        // 监听个人信息
        needInfo(name) {
            let watchAch = this.$watch("info", (val, oldVal) => {
                if (val) {
                this[name]();
                watchAch(); //取消监听
                }
            });
        },
        // 点击收藏或者取消收藏
        collectionCourse(){
            if(!this.international_master_detail.isCollection){
                // 收藏
                this.createFrontCollection()
            }else{
                // 取消收藏
                this.deleteFrontCollection()
            }
            
        },
        // 收藏
        createFrontCollection(){
            // 未登录
            if(!this.$store.state.info){
                this.$store.dispatch("setIsLoginDialog", true);
                return;
            }
            let obj = {
                type:'CollectionTypeCollect',
                code:this.international_master_detail.code,
                entity_type:'EntityTypeCollege'
            }
            this.api.createFrontCollection(obj,true)
            .then(res => {
                if(res.error.err_code !== 0) return;
                this.$message({
                    message:'收藏成功！',
                    type:'success'
                });
                // this.video_list = []
                // this.getFrontColleges()
                this.international_master_detail.isCollection = true
            })
        },
        // 取消收藏
        deleteFrontCollection(){
            // 未登录
            if(!this.$store.state.info){
                this.$store.dispatch("setIsLoginDialog", true);
                return;
            }
            this.api.deleteFrontCollection({code:this.international_master_detail.code},true)
            .then(res => {
                if(res.error.err_code != 0) return;
                this.$message({
                    message:'您已取消收藏！',
                    type:'info'
                })
                // this.video_list = []
                this.international_master_detail.isCollection = false
            })
        },
        
    }
    
}
</script>

<style lang="scss">
@import url('../../peronsal_center/index.scss');
.school_design_detail{
    width: 1200px;
    margin: 40px auto;
    .design_detail_title{
        font-size:24px;
        color:$font-black;
        line-height: 30px;
    }
    .design_detail_use{
        line-height: 45px;
        span{
            margin-right: 10px;
            color: #AAAAAA; 
            .my_icon{
                margin-right: 5px;
            }
        }
    }
    // 视频播放器
    .design_detail_video{
        display: flex;
        .video_player{
            width:880px;
            height:495px;
        }
        .video_catalog{
            position: relative;
            width:320px;
            height:495px;
            background:$bg-white;
            .catalog_title{
                padding: 30px 20px;
                display: flex;
                justify-content: space-between;
                font-size:16px;
                color:$font-black;
                .love{
                    cursor: pointer;
                    .loved{
                        background-color: red;  
                        border: 1px solid red;
                    }
                }
                
            }
            .catalog_content{
                .catalog_content_item{
                    background-color: rgb(245, 245, 245);
                    padding: 0 20px;
                    line-height: 50px;
                    cursor: pointer; 
                    display: flex;
                    justify-content: space-between;
                    .catalog_content_icon{
                        // margin-right: 10px;
                        // margin-top: 30px;   
                        // display: inline-block;
                        padding-top: 2px;

                    }
                    .catalog_content_name{
                        // display: inline-block;
                        width: 240px;
                        font-size:14px;
                        color:#333;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap;
                        word-wrap:normal;
                    }
                }
                .active{
                    background:rgba(245,245,245,1);
                }
            }
            .free_btn{
                padding: 0 20px;
                position: absolute;
                bottom: 20px;
                .el-button{
                    width:280px;
                    height:42px;
                    background:rgba(17,17,17,1);
                    color: $bg-white;
                }
                .applyed{
                    background:#444444;
                    color: $bg-white;
                }
            }
        }
    }
    .course_about_wrapper{
        display: flex;
        margin-top: 20px;
        .course_about_left{
            .course_about{
                width:859px;
                background:$bg-white;
                margin-right: 20px;
                padding: 0 20px;
                box-sizing: border-box;
                .el-tab-pane{
                    padding-top: 10px;
                    box-sizing: border-box;
                    // 课程概述
                    // .course_overview{
                    // }
                    // 评论
                    .course_comment{
                        .unlogin_comment{
                            width:819px;
                            height:100px;
                            background:rgba(245,245,245,1);
                            border:1px solid rgba(238,238,238,1);
                            .unlogin_comment_btn{
                                font-size:14px;
                                color:$font-black;
                                margin: 35px 310px;
                                .el-button{
                                    width:100px;
                                    height:36px;
                                    background:rgba(17,17,17,1);
                                    color: $font-white;
                                    margin-right: 10px;
                                } 
                            }
                            
                        }
                        .login_comment{
                            .el-textarea{
                                position: relative;
                                .el-input__count{
                                    background-color: rgb(245, 245, 245);
                                    position: absolute;
                                    top: 70px;
                                    font-size: 14px;
                                }
                                .el-textarea__inner{
                                    resize:none;
                                    height: 100px;
                                    padding-top: -10px;
                                    background:rgba(245,245,245,1);
                                }
                                .el-textarea__inner:focus{
                                    border:1px solid rgba(238,238,238,1);
                                }
                            }
                        }
                        .send_btn{
                            margin-top: 20px;
                            text-align: right;
                            .el-button{
                                width:100px;
                                height:36px;
                                background:rgba(245,245,245,1);
                                font-size:14px;
                                color:rgba(181,181,181,1);
                            }
                            .activeSend{
                                background:rgba(17,17,17,1);
                                color:$font-white;
                            }
                        }
                        .comment_list{
                            .comment_item:last-of-type{
                                border-bottom: none;
                            }
                            .comment_item{
                                box-sizing: border-box;
                                padding: 30px 0;
                                display: flex;
                                border-bottom:1px solid rgba(240,240,240,1);
                                .comment_item_avatar{ 
                                    margin-right: 20px;         
                                    img{
                                        width:50px;
                                        height:50px;
                                        border-radius:50%;
                                    }
                                }
                                .comment_item_content{
                                    .content_username{
                                        line-height: 35px;
                                        font-size:14px;
                                        font-weight:bold;
                                        color:rgba(51,51,51,1);
                                    }
                                    .content_wrapper{
                                        line-height: 35px;
                                        font-size:14px;
                                        color:rgba(102,102,102,1);
                                    }
                                    .content_date{
                                        line-height: 30px;
                                        font-size:12px;
                                        color:rgba(153,153,153,1);
                                    }
                                }
                            }
                        }
                        .noComment{
                            line-height: 50px;
                            text-align: center;
                            font-size: 20px;
                            color: #666666;
                        }
                        .page_box{
                            margin-left: 130px;
                        }
                    }
                }
                
            }
        }
        .course_about_right{
            .keynote_speaker{
                width:320px;
                background:$bg-white;
                padding: 0 20px 20px;
                box-sizing: border-box;
                .keynote_speaker_content{
                    .keynote_speaker_img{
                        text-align: center;
                        line-height: 120px;
                        img{
                            width:100px;
                            height:100px;
                            border-radius:50%;
                            vertical-align: bottom;
                        }
                    }
                    .keynote_speaker_name{
                        font-size:14px;
                        color:rgba(51,51,51,1);
                        line-height: 50px;
                        text-align: center;
                    }   
                    .keynote_speaker_introduce{
                        text-align: center;
                        line-height: 25px;
                        font-size:13px;
                        color:rgba(153,153,153,1);
                    }
                }
            }
            // 相关推荐
            .related_recommendation{
                width: 320px;
                background-color: $bg-white;
                padding: 0 20px;
                box-sizing: border-box;
                margin-top: 20px;
                ul{
                    padding: 30px 0 1px;
                    box-sizing: border-box;
                    .related_recommendation_content{
                        a{
                            display: flex;
                            margin-bottom: 15px;
                            cursor: pointer;
                            color: #333;
                            .recommendation_content_left{
                                img{
                                    width:130px;
                                    height:74px;
                                    margin-right: 10px;
                                }
                            }
                            .recommendation_content_right{
                                padding: 8px 0;
                                box-sizing: border-box;
                                .recommendation_name{
                                    font-size:14px;
                                    color:rgba(51,51,51,1);
                                    line-height:20px;
                                    height: 40px;
                                    overflow:hidden;
                                    text-overflow:ellipsis;
                                    display:-webkit-box;
                                    -webkit-line-clamp:2;  
                                    -webkit-box-orient:vertical;
                                }
                                .looked{
                                    font-size:12px;
                                    color:rgba(153,153,153,1);
                                    line-height:24px;
                                }
                            }
                        }
                    }
                    .related_recommendation_content:last-of-type{
                        margin-bottom: 0;
                    }
                }
            }
        }
        
    }
}
</style>